export default __webpack_public_path__ + "static/media/manage-roles.3a438bee.svg";